import { Inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { UnespCoreEnvironment } from 'src/libs/unesp-core'
import { identity, Observable } from 'rxjs'
import { ErrorHandlerService } from './error-handler.service'

export interface AnotacaoProvaDTO {
  id: number
  texto: string
  pagina: number | null
  criadoEm: string
  editadoEm: string | null
}

export interface AnotacaoProvaPayload {
  texto: string
  pagina?: number | null
  tipoProva?: string
}

@Injectable({
  providedIn: 'root',
})
export class AnotacaoProvaService {
  private baseUrl: string

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    @Inject('environment') env: UnespCoreEnvironment
  ) {
    this.baseUrl = env.baseUrlApi
  }

  // ========== Endpoints via HASH (prova escrita — anonimizado) ==========

  listarPorHash(hash: string, documentoId: number): Observable<AnotacaoProvaDTO[]> {
    return this.http
      .get<AnotacaoProvaDTO[]>(`${this.baseUrl}/comissao/anotacoes/prova-escrita/${hash}/${documentoId}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  criarPorHash(hash: string, documentoId: number, payload: AnotacaoProvaPayload): Observable<AnotacaoProvaDTO> {
    return this.http
      .post<AnotacaoProvaDTO>(`${this.baseUrl}/comissao/anotacoes/prova-escrita/${hash}/${documentoId}`, payload)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  editarPorHash(hash: string, documentoId: number, id: number, payload: AnotacaoProvaPayload): Observable<AnotacaoProvaDTO> {
    return this.http
      .put<AnotacaoProvaDTO>(`${this.baseUrl}/comissao/anotacoes/prova-escrita/${hash}/${documentoId}/${id}`, payload)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  excluirPorHash(hash: string, documentoId: number, id: number): Observable<void> {
    return this.http
      .delete<void>(`${this.baseUrl}/comissao/anotacoes/prova-escrita/${hash}/${documentoId}/${id}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  // ========== Endpoints via complementoId (demais provas — não anônimo) ==========

  listar(complementoId: number): Observable<AnotacaoProvaDTO[]> {
    return this.http
      .get<AnotacaoProvaDTO[]>(`${this.baseUrl}/comissao/anotacoes/prova/${complementoId}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  criar(complementoId: number, payload: AnotacaoProvaPayload): Observable<AnotacaoProvaDTO> {
    return this.http
      .post<AnotacaoProvaDTO>(`${this.baseUrl}/comissao/anotacoes/prova/${complementoId}`, payload)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  editar(complementoId: number, id: number, payload: AnotacaoProvaPayload): Observable<AnotacaoProvaDTO> {
    return this.http
      .put<AnotacaoProvaDTO>(`${this.baseUrl}/comissao/anotacoes/prova/${complementoId}/${id}`, payload)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  excluir(complementoId: number, id: number, tipoProva: string): Observable<void> {
    return this.http
      .delete<void>(`${this.baseUrl}/comissao/anotacoes/prova/${complementoId}/${id}`, {
        params: { tipoProva },
      })
      .pipe(identity, this.errorHandlerService.catchError())
  }
}
